import Button from "../../base/Button";

const renderIcon = (color) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <g fill="none" fillRule="evenodd" stroke={color} strokeLinecap="square">
            <path d="M1.25 19h4v4h-4zM10.25 10h4v4h-4zM1.25 10h4v4h-4zM10.25 1h4v4h-4zM1.25 1h4v4h-4zM19.25 1h4v4h-4zM10.25 21h4M12.25 19v4M19.25 21h4M21.25 19v4M19.25 12h4M21.25 10v4" />
        </g>
    </svg>
);

/**
 * Toolbar button for manual selection mode.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered manual button.
 */
const ManualButton = (props) => <Button {...props} renderIcon={renderIcon} />;

export default ManualButton;
